document.addEventListener("DOMContentLoaded", () => {
    setTimeout(function() {
        const dropdownItems = document.querySelectorAll(".dropdown-list--item");
        if (dropdownItems.length > 0) {
            changePriceVariant();
        }
        dropdownItems.forEach(item => {
            item.addEventListener("click", () => {
                changePriceVariant();
            });
        });
    }, 100);
    function changePriceVariant() {
        setTimeout(() => {
            const variantInput = document.querySelector("form input[name='id']");
            if (!variantInput) return;
            const variantId = parseInt(variantInput.value);
            const variant = jsProduct.variants.find(v => v.id === variantId);
            if (!variant) return;
            const priceElement = document.getElementById("ProductPrice");
            if (priceElement) {
                priceElement.innerText = variant.price_formatted;
            }
        }, 200);
    }
});